import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() => ({
  name: {
    lineHeight: '22px',
    fontSize: '14px',
  },
  id: {
    lineHeight: '21px',
    fontSize: '14px',
    letterSpacing: '0.1px',
  },
}))
